import { api } from "../../src/component/constent";
// ============================================================
// RAILWAYS
// ============================================================

export const getPOHRailways = () => {
    return api.get(`/entry/railways`);
};


// ============================================================
// CURRENT MONTH
// ============================================================

export const getPOHCurrentMonth = () => {
    return api.get(`/entry/current-month`);
};


// ============================================================
// OPTIONS
// ============================================================

export const getPOHOptions = () => {
    return api.get(`/entry/options`);
};


// ============================================================
// LIST
// ============================================================

export const getPOHList = (month, year) => {

    return api.get(`/entry/poh`, {
        params: {
            month,
            year
        }
    });

};


// ============================================================
// CREATE
// ============================================================

export const createPOH = (data) => {

    return api.post(
        `/entry/poh`,
        data
    );

};


// ============================================================
// UPDATE
// ============================================================

export const updatePOH = (
    oldRail,
    oldPOHType,
    oldPOHSubType,
    data
) => {

    return api.put(
        `/entry/poh/${encodeURIComponent(oldRail)}/${encodeURIComponent(oldPOHType)}/${encodeURIComponent(oldPOHSubType)}`,
        data
    );

};


// ============================================================
// DELETE
// ============================================================

export const deletePOH = (data) => {

    return api.delete(
        `/entry/poh`,
        {
            data
        }
    );

};